import React, { useState, useEffect, useLayoutEffect } from 'react';
import EsteticaHeader from './components/EsteticaHeader';
import EsteticaHome from './components/EsteticaHome';
import EsteticaFaciales from './components/EsteticaFaciales';
import EsteticaCorporales from './components/EsteticaCorporales';
import EsteticaMasajes from './components/EsteticaMasajes';
import EsteticaFooter from './components/EsteticaFooter';

function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const [showScrollTop, setShowScrollTop] = useState(false);

  // Al cambiar de sección, empezar siempre desde arriba (sin animación, para que no se vea el salto)
  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [currentPage]);

  // Mostrar el botón "volver arriba" solo después de bajar un poco
  useEffect(() => {
    const onScroll = () => setShowScrollTop(window.scrollY > 300);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const renderPage = () => {
    switch (currentPage) {
      case 'home':
        return <EsteticaHome setCurrentPage={setCurrentPage} />;
      case 'faciales':
        return <EsteticaFaciales />;
      case 'corporales':
        return <EsteticaCorporales />;
      case 'masajes':
        return <EsteticaMasajes />;
      case 'contacto':
        return (
          <section className="min-h-screen bg-gradient-to-b from-white to-green-50 pt-24 pb-16 px-4">
            <div className="container mx-auto">
              <div className="max-w-6xl mx-auto">
                <div className="text-center mb-12">
                  <h1 className="text-4xl md:text-5xl font-bold text-green-900 mb-4 font-serif">
                    Contáctanos
                  </h1>
                  <p className="text-lg text-green-800 max-w-2xl mx-auto">
                    Estamos aquí para responder tus preguntas y ayudarte a reservar tu próxima experiencia de belleza.
                  </p>
                </div>

                <div className="grid md:grid-cols-2 gap-8">
                  {/* Información de contacto */}
                  <div className="bg-white rounded-2xl shadow-xl p-8 md:p-10">
                    <div className="space-y-6">
                      <div className="flex items-start">
                        <div className="bg-green-100 p-3 rounded-full flex-shrink-0">
                          <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                          </svg>
                        </div>
                        <div className="ml-4">
                          <h3 className="text-xl font-semibold text-gray-800">Teléfono</h3>
                          <p className="text-green-600 mt-1">+595 986 523658</p>
                        </div>
                      </div>

                      <div className="flex items-start">
                        <div className="bg-green-100 p-3 rounded-full flex-shrink-0">
                          <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                          </svg>
                        </div>
                        <div className="ml-4">
                          <h3 className="text-xl font-semibold text-gray-800">Email</h3>
                          <p className="text-green-600 mt-1">cleoestetica00@gmail.com</p>
                        </div>
                      </div>

                      <div className="flex items-start">
                        <div className="bg-green-100 p-3 rounded-full flex-shrink-0">
                          <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                          </svg>
                        </div>
                        <div className="ml-4">
                          <h3 className="text-xl font-semibold text-gray-800">Dirección</h3>
                          <p className="text-green-600 mt-1">Caacupé, Paraguay</p>
                        </div>
                      </div>

                      <div className="pt-6">
                        <h3 className="text-xl font-semibold text-gray-800 mb-4">Horario de Atención</h3>
                        <div className="space-y-3">
                          <div className="flex justify-between items-center pb-2 border-b border-green-100">
                            <span className="text-gray-700">Lunes - Viernes</span>
                            <span className="font-medium text-green-600">9:00 - 18:30</span>
                          </div>
                          <div className="flex justify-between items-center pb-2 border-b border-green-100">
                            <span className="text-gray-700">Sábados</span>
                            <span className="font-medium text-green-600">9:00 - 14:00</span>
                          </div>
                          <div className="flex justify-between items-center">
                            <span className="text-gray-700">Domingos</span>
                            <span className="font-medium text-red-500">Cerrado</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Formulario de contacto */}
                  <div className="bg-white rounded-2xl shadow-xl p-8 md:p-10">
                    <h2 className="text-2xl font-bold text-green-900 mb-6">Envíanos un mensaje</h2>
                    <form 
                      action="https://formspree.io/f/xkgzrgav" 
                      method="POST"
                      className="space-y-5"
                    >
                      <div>
                        <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">Nombre</label>
                        <input 
                          type="text" 
                          id="name" 
                          name="name"
                          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 transition"
                          placeholder="Tu nombre"
                          required
                        />
                      </div>
                      <div>
                        <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                        <input 
                          type="email" 
                          id="email" 
                          name="email"
                          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 transition"
                          placeholder="tu@email.com"
                          required
                        />
                      </div>
                      <div>
                        <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1">Teléfono</label>
                        <input 
                          type="tel" 
                          id="phone" 
                          name="phone"
                          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 transition"
                          placeholder="+595 986 523658"
                        />
                      </div>
                      <div>
                        <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">Mensaje</label>
                        <textarea 
                          id="message" 
                          name="message"
                          rows="4"
                          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 transition"
                          placeholder="Cuéntanos cómo podemos ayudarte..."
                          required
                        ></textarea>
                      </div>
                      <div>
                        <button 
                          type="submit" 
                          className="w-full bg-gradient-to-r from-green-600 to-emerald-500 text-white font-bold py-3 px-6 rounded-lg hover:opacity-90 transition-all duration-300 shadow-lg hover:shadow-xl"
                        >
                          Enviar Mensaje
                        </button>
                      </div>  
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </section>
        );
      default:
        return <EsteticaHome setCurrentPage={setCurrentPage} />;
    }
  };

  return (
    <div className="font-sans antialiased bg-crema flex flex-col min-h-screen">
      <EsteticaHeader setCurrentPage={setCurrentPage} />
      
      <main key={currentPage} className="flex-1 animate-page-in">
        {renderPage()}
      </main>
      
      <EsteticaFooter />
      
      {/* Botón flotante de WhatsApp mejorado */}
      <a
        href="https://wa.me/+595986523658"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 w-16 h-16 bg-[#25D366] text-white rounded-full shadow-2xl hover:bg-[#128C7E] transition-all duration-300 flex items-center justify-center z-50 group"
        aria-label="Contactar por WhatsApp"
      >
        <svg className="w-10 h-10" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
        </svg>
        <span className="absolute right-20 bg-gray-900 text-white text-sm px-3 py-1 rounded-md opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap">
          ¡Escríbenos!
        </span>
      </a>
      
      {/* Botón de scroll to top */}
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        className={`fixed bottom-6 left-6 w-12 h-12 bg-green-600 text-white rounded-full shadow-2xl flex items-center justify-center z-50 transition-opacity duration-300 ${showScrollTop ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
        aria-label="Volver arriba"
      >
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 10l7-7m0 0l7 7m-7-7v18" />
        </svg>
      </button>
    </div>
  );
}

export default App;